// extracted by mini-css-extract-plugin
module.exports = {"headTitle":"ManagePost_headTitle__1HwhS"};